/**
 * Copyright(c) 2022 Fenix Outdoor International AG.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Fenix ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Fenix.
 *
 */
import React, { useState } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import NavbarBrand from "../../../common/core/NavbarBrand";
import Dropdown from "../../../common/core/Dropdown";
import DropdownToggle from "../../../common/core/DropdownToggle";
import DropdownMenu from "../../../common/core/DropdownMenu";
import DropdownItem from "../../../common/core/DropdownItem";
import Logo from "../../../common/assets/images/fenix-logo.svg";
import UserData from "../../../common/security/UserData";

const Header = (props) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const history = useHistory();

  const handlelogout = () => {
    props.handleLogout();
    history.push("/login");
  };

  const getUserName = () => {
    const userName = UserData.getName();
    if (userName) {
      return userName;
    }
    return "User";
  };

  const handleChangePassword = () => {
    history.push("/change-password");
  };

  return (
    <header>
      <NavbarBrand href="/">
        <img src={Logo} alt="" />
      </NavbarBrand>
      <div className="header-right">
        <Dropdown className="notifications-dropdown active">
          {/* <DropdownToggle color="transparent">
            <i className="fal fa-bell"> </i>
            <span> </span>
          </DropdownToggle> */}
          {/* <DropdownMenu right>
            <DropdownItem>
              <i className="fal fa-lock-alt"> </i>
              <span>Change Password</span>
            </DropdownItem>
            <DropdownItem onClick={handlelogout}>
              <i className="fal fa-sign-out"> </i>
              <span>Logout</span>
            </DropdownItem>
          </DropdownMenu> */}
        </Dropdown>

        <div className="hr-spacer"> </div>

        <Dropdown isOpen={dropdownOpen} toggle={toggle} className="myaccount-dropdown">
          <DropdownToggle caret color="transparent">
            Welcome &nbsp;
            <span>{getUserName()}</span>
          </DropdownToggle>
          <DropdownMenu right>
            <DropdownItem onClick={handleChangePassword}>
              <i className="fal fa-lock-alt"> </i>
              <span>Change Password</span>
            </DropdownItem>
            <DropdownItem onClick={handlelogout} className="text-danger">
              <i className="fal fa-sign-out"> </i>
              <span>Logout</span>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    </header>
  );
};

Header.propTypes = {
  handleLogout: PropTypes.func.isRequired,
};

export default Header;
